/* Cloudflare Turnstile helper (shared).
 *
 * Self-bootstraps the Turnstile api.js from the bundle — deliberately NOT injected by
 * beginHead_01 — because the Hub (disabilityhubmn.org) loads this bundle from mn.db101.org
 * but never runs our page head, and the dialog fetch strips scripts. One code path for our
 * own sites AND the Hub. Uses window.turnstile (separate namespace from the Hub's own
 * grecaptcha v3, so no collision).
 *
 * Sitekey: public (not a secret). Baked-in default, overridable via
 * window.logon$services.turnstileSitekey.
 *
 * API (also exposed as window.efwTurnstile):
 *   mount(el)      ensure api.js, render an interaction-only widget into el (idempotent;
 *                  resets if already mounted). Reads the action from el's data-tsaction.
 *   token(el)      current response token for el's widget ('' if none/not ready).
 *   reset(el)      reset el's widget (tokens are single-use, ~300s TTL).
 */
/* global require, module, window, document */
'use strict';

var API_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=__efwTsOnload';
var DEFAULT_SITEKEY = '0x4AAAAAADpQvSZcQHVTZJYj';

function _sitekey() {
    return (window.logon$services && window.logon$services.turnstileSitekey) || DEFAULT_SITEKEY;
}

var _loading = false,
    _queue = [];

// Ensure api.js is present, then invoke cb once window.turnstile is ready.
function ensureApi(cb) {
    if (window.turnstile) { cb(); return; }
    _queue.push(cb);
    if (_loading) return;
    _loading = true;

    window.__efwTsOnload = function () {
        var q = _queue.slice();
        _queue = [];
        for (var i = 0; i < q.length; i++) {
            try { q[i](); } catch (e) { if (window.console) console.warn('turnstile cb', e); }
        }
    };

    var s = document.createElement('script');
    s.src = API_SRC;
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
}

function mount(el) {
    if (!el) return;
    ensureApi(function () {
        var existing = el.getAttribute('data-ts-widget-id');
        if (existing) {                                   // already rendered — just refresh
            try { el.removeAttribute('data-ts-error'); } catch (e2) { /* ignore */ }
            try { window.turnstile.reset(existing); } catch (e) { /* ignore */ }
            return;
        }
        try {
            var id = window.turnstile.render(el, {
                sitekey: _sitekey(),
                action: el.getAttribute('data-tsaction') || undefined,
                appearance: 'interaction-only',
                'refresh-expired': 'auto',  // re-issue silently if the ~300s token expires before submit
                // Record the widget outcome on the element so the beacon's failReason() can report a real
                // Cloudflare error-callback code (network/challenge error) instead of guessing "unsolved".
                // error-callback returns nothing => default error UI is preserved; success clears the code.
                callback: function () { try { el.removeAttribute('data-ts-error'); } catch (e2) { } },
                'error-callback': function (code) { try { el.setAttribute('data-ts-error', String(code || 'error')); } catch (e2) { } }
            });
            el.setAttribute('data-ts-widget-id', id);
        } catch (e) {
            if (window.console) console.warn('turnstile render failed', e);
        }
    });
}

function token(el) {
    if (!el || !window.turnstile) return '';
    var id = el.getAttribute('data-ts-widget-id');
    if (!id) return '';
    try { return window.turnstile.getResponse(id) || ''; } catch (e) { return ''; }
}

function reset(el) {
    if (!el || !window.turnstile) return;
    var id = el.getAttribute('data-ts-widget-id');
    if (!id) return;
    try { el.removeAttribute('data-ts-error'); } catch (e2) { /* ignore */ }
    try { window.turnstile.reset(id); } catch (e) { /* ignore */ }
}

// Classify why token() came back empty, for the widget-health beacon.
function failReason(el) {
    if (!window.turnstile) return 'not-loaded';                            // api.js blocked (CSP/network/CF outage)
    if (!el || !el.getAttribute('data-ts-widget-id')) return 'not-mounted'; // autowire never rendered the widget
    var err = el.getAttribute('data-ts-error');
    if (err) return 'error-' + err;                                        // CF error-callback fired: real widget error
    return 'unsolved';                                                     // mounted, no error, no token: unsolved/expired
}

// Fire-and-forget widget-health beacon to Logon: real-user solve-vs-fail AT SUBMIT — the signal neither
// Cloudflare (issuance only) nor server siteverify (submitted tokens only) can see, since the submit-gate
// blocks a tokenless submit before it POSTs. event: 'solved' | 'failed' (reason derived for 'failed').
// Never throws, never blocks the UI.
function beacon(logonService, event, action, el) {
    try {
        // Logon forms pass their opts.logonService; other surfaces (estimator share/pdf, feedback)
        // pass null and fall back to the global logon$services.logonService (env-correct: preview-logon
        // on preview tiers, logon on prod) so the beacon reaches the right Logon.
        var base = logonService || (window.logon$services && window.logon$services.logonService) || '';
        var url = base + '/api/Turnstile/Beacon';
        var payload = JSON.stringify({
            event: event,
            reason: event === 'failed' ? failReason(el) : null,
            action: action || null,
            hostname: window.location.host
        });
        // sendBeacon posts text/plain => a CORS "simple request": no preflight on the cross-origin POST to Logon.
        if (navigator && navigator.sendBeacon) {
            navigator.sendBeacon(url, payload);
        } else if (window.fetch) {
            fetch(url, { method: 'POST', body: payload, keepalive: true, mode: 'no-cors' }).catch(function () { });
        }
    } catch (e) { /* telemetry must never break the flow */ }
}

// Auto-mount: any .cf-turnstile-slot landmark on the page is rendered without per-form code.
// Modal slots aren't visible at load, so we mount them on bootstrap's show.bs.modal; inline
// (non-modal) slots are mounted at ready. mount() is idempotent, so a form that also calls
// mount() itself is harmless. Per-form code still only needs token()/reset() at submit.
var _autowired = false;
function autowire() {
    var $ = window && window.jQuery;
    if (!$ || _autowired) return;
    _autowired = true;
    $(document).on('show.bs.modal', function (e) {
        $(e.target).find('.cf-turnstile-slot').each(function () { mount(this); });
    });
    $(function () {
        $('.cf-turnstile-slot').each(function () {
            var $s = $(this);
            // visible inline slots only; modals mount on show; slots hidden at load (e.g. the PDF
            // "email this report" block, revealed after the report completes) are mounted on reveal
            // by their owner so the token doesn't go stale before submit.
            if (!$s.closest('.modal').length && $s.is(':visible')) mount(this);
        });
    });
}

var api = { mount: mount, token: token, reset: reset, ensureApi: ensureApi, autowire: autowire, beacon: beacon };

if (typeof window !== 'undefined') {
    window.efwTurnstile = api;
    if (window.jQuery) autowire();
    else if (window.addEventListener) window.addEventListener('load', autowire);   // jQuery not yet global
}
module.exports = api;
